import { StyleSheet } from 'react-native';
import { stdCouleurBleu } from '@commonStyle';

const styles = StyleSheet.create({
  backdrop: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 10,
    cursor: 'auto',
  },
  
  container: {
    backgroundColor: 'white',
    borderRadius: 20,
    overflow: 'hidden',
    maxHeight: '100%', // Limite la hauteur maximale à 100% de l'écran
    maxWidth: '100%',  // Limite la largeur maximale à 100% de l'écran
    minWidth: 300,    // Largeur minimale pour éviter des popups trop petites
    // Ombres pour iOS et Web
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.3,
    shadowRadius: 8,
    // Elevation pour Android
    elevation: 8,
    cursor: 'auto',
  },

  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingVertical: 16,
    paddingHorizontal: 20,
    borderBottomWidth: 1,
    borderBottomColor: '#e0e0e0',
    backgroundColor: '#fafafa',
  },

  title: {
    flex: 1,
    fontSize: 18,
    fontWeight: '600',
    color: stdCouleurBleu,
    marginRight: 10,
  },

  closeButton: {
    padding: 4,
    borderRadius: 20,
    backgroundColor: 'rgba(0, 0, 0, 0.05)',
  },

  content: {
    paddingHorizontal: 10,
    paddingVertical: 16,
    flexShrink: 1,
    flex: 1,
  },

  fullScreenContainer: {
    flex: 1,
    width: '100%',
  },

  fullScreenBackdrop: {
    padding: 0,
    justifyContent: 'flex-start',
    alignItems: 'stretch',
  },
});

export default styles;